import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Card, CardText } from 'material-ui/Card';
import compose from 'recompose/compose';
import inflection from 'inflection';
import { reset } from 'redux-form';
import {
  translate as t,
  Responsive,
} from 'admin-on-rest';
import ViewTitle from 'admin-on-rest/lib/mui/layout/ViewTitle';
import Title from 'admin-on-rest/lib/mui/layout/Title';
import {
  crudGetOne as crudGetOneAction,
  crudUpdate as crudUpdateAction,
} from 'admin-on-rest/lib/actions/dataActions';
import DefaultActions from 'admin-on-rest/lib/mui/detail/EditActions';
import withPermissionsFilteredChildren from 'admin-on-rest/lib/auth/withPermissionsFilteredChildren';
import { CircularProgress } from 'material-ui';

export class Edit extends Component {
  componentDidMount() {
    this.updateData();
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.id !== nextProps.id ||
            nextProps.version !== this.props.version
    ) {
      this.props.resetForm('record-form');
      this.updateData(nextProps.resource, nextProps.id);
    }
  }

  getBasePath() {
    const { location } = this.props;
    return location.pathname
      .split('/')
      .slice(0, -1)
      .join('/');
  }

  defaultRedirectRoute() {
    return 'list';
  }

  updateData(resource = this.props.resource, id = this.props.id) {
    this.props.crudGetOne(resource, id, this.getBasePath());
  }

    save = (record, redirect) => {
      this.props.crudUpdate(
        this.props.resource,
        this.props.id,
        record,
        this.props.data,
        this.getBasePath(),
        redirect
      );
    };

    render() {
      const {
        actions = <DefaultActions />,
        children,
        data,
        hasDelete,
        hasShow,
        hasList,
        id,
        isLoading,
        resource,
        title,
        translate,
        version,
      } = this.props;

      if (!children) return null;

      const basePath = this.getBasePath();

      const resourceName = translate(`resources.${resource}.name`, {
        smart_count: 1,
        _: inflection.humanize(inflection.singularize(resource)),
      });
      const defaultTitle = translate('aor.page.edit', {
        name: `${resourceName}`,
        id,
        data,
      });
      const titleElement = data ? (
        <Title title={title} record={data} defaultTitle={defaultTitle} />
      ) : (
        ''
      );

      return (
        <div className="edit-page">
          {isLoading && (
            <Responsive
              small={
                <div style={{ zIndex: 999, position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(255,255,255,0.2)', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <CircularProgress />
                </div>
              }
              medium={<span></span>}
            />
          )}
          <Card style={{ opacity: isLoading ? 0.8 : 1 }}>
            {actions && React.cloneElement(actions, {
              basePath,
              data,
              hasDelete,
              hasShow,
              hasList,
              resource,
            })}
            <ViewTitle title={titleElement} />
            <br />
            {data && data.createdAt && <div style={{ paddingLeft: '16px', fontSize: '11px', opacity: 0.8 }}>Created at: {data.createdAt}</div>}
            {data && data.submittedBy && <div style={{ paddingLeft: '16px', fontSize: '11px', opacity: 0.8 }}>Created by: {data.submittedBy.fullName || data.submittedBy.username || data.submittedBy}</div>}
            {data && data.updatedAt && <div style={{ paddingLeft: '16px', fontSize: '11px', opacity: 0.8 }}>Updated at: {data.updatedAt}</div>}
            {data && data.lastUpdatedBy && <div style={{ paddingLeft: '16px', fontSize: '11px', opacity: 0.8 }}>Last updated by: {data.lastUpdatedBy.fullName || data.lastUpdatedBy.username || data.lastUpdatedBy}</div>}
            <br />
            {data ? (
              React.cloneElement(children, {
                save: this.save,
                resource,
                basePath,
                record: data,
                translate,
                version,
                redirect: typeof children.props.redirect === 'undefined' ? this.defaultRedirectRoute() : children.props.redirect,
              })
            ) : (
              <CardText>&nbsp;</CardText>
            )}
          </Card>
        </div>
      );
    }
}

Edit.propTypes = {
  actions: PropTypes.element,
  children: PropTypes.node,
  crudGetOne: PropTypes.func.isRequired,
  crudUpdate: PropTypes.func.isRequired,
  data: PropTypes.object,
  hasDelete: PropTypes.bool,
  hasShow: PropTypes.bool,
  hasList: PropTypes.bool,
  id: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
  location: PropTypes.object.isRequired,
  resource: PropTypes.string.isRequired,
  title: PropTypes.any,
  translate: PropTypes.func,
  version: PropTypes.number.isRequired,
};

function mapStateToProps(state, props) {
  return {
    id: decodeURIComponent(props.match.params.id),
    data: state.admin.resources[props.resource]
      ? state.admin.resources[props.resource].data[
        decodeURIComponent(props.match.params.id)
      ]
      : null,
    isLoading: state.admin.loading > 0,
    version: state.admin.ui.viewVersion,
  };
}

const enhance = compose(
  connect(mapStateToProps, {
    crudGetOne: crudGetOneAction,
    crudUpdate: crudUpdateAction,
    resetForm: reset,
  }),
  t,
  withPermissionsFilteredChildren
);

export default enhance(Edit);
